<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <a class="close-btn" mat-dialog-close><i class="ri-close-fill"></i></a>
    </div>
    <mat-dialog-content>
        <div class="text-center">
            <form [formGroup]="verificationForm" novalidate>
                <img src="../../../../assets/images/mail-icon.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-center text-primary">Authentication Code</h5>
                <p>Authentication Code has been successfully sent to <br />your registered email.
                    <a href="#" class="text-white text-decoration-underline" (click)="$event.preventDefault()">
                        {{ emailId }}
                    </a>
                </p>
                <div class="form-group mb-3 d-flex justify-content-center gap-3 otp-bar flex-wrap">
                    <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput [config]="config"></ng-otp-input>
                </div>
                <div class="expire-info mt-4">
                    <ng-container *ngIf="counter > 0; else expiredBlock">
                        <p class="m-0">Code will expire in <span>{{ minutes }}:{{ seconds | number: '2.0' }}</span>
                        </p>
                    </ng-container>
                    <ng-template #expiredBlock>
                        <p class="m-0"><span class="text-danger">Time Expired</span></p>
                    </ng-template>
                </div>

                <button matButton="filled" type="submit" class="w-100 btn-primary my-3" [disabled]="submitted == true"
                    (click)="verifyCode()">
                    Verify
                </button>
                <div class="resend-info mt-3">
                    <ng-container *ngIf="isResendDisabled; else resendActive">
                        <p class="mb-1">Don’t receive the code?</p>
                        <span class="text-muted small d-block">Resend code in {{ resendCooldown }} seconds</span>
                    </ng-container>
                    <ng-template #resendActive>
                        <p class="m-0">Don’t receive the code?
                            <a href="javascript:void(0)" class="cursor-pointer ms-1 text-decoration-none"
                                (click)="ResendOTP()">Resend Code</a>
                        </p>
                    </ng-template>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>